import React, { FC, useEffect, useState } from 'react';
import { Button, Form, Grid, Header, Image, Message, Container, Checkbox, Input } from 'semantic-ui-react'
import TopBar from '../../../../components/topBar/topBar';
import Breadcrumb from '../../../../components/breadcrumb/breadcrumb';
import { useDispatch, useSelector } from 'react-redux';
import { fetchMediumData } from '../../../../store/getMediumData/action';
import { postCreditServiceInit } from '../../../../store/postCreditService/action';
import { closeSuccessBar } from '../../../../store/message/action';
import { getQuickDiscountValues } from '../../../../interfaces/discountValue';

const EnterMediumWidget: FC<any> = () => {
    const dispatch = useDispatch();
    const mediumData = useSelector((state: any) => state.getMediumData);
    const postCreditService = useSelector((state: any) => state.postCreditService);
    const successBar = useSelector((state: any) => state.message.successBar);
    const userData = useSelector((state: any) => state.auth.user);
    const [mediumNumber, setMediumNumber]: any = useState('');

    // exactly one quick button: "Bestätigen" books its amount directly, without the detail page
    const quickDiscountValues = getQuickDiscountValues(userData);
    const singleQuickCreditAmountInCent = quickDiscountValues.length === 1
        ? Math.round(Number(quickDiscountValues[0].discountValue) * 100)
        : undefined;

    const isPending = mediumData.pending || postCreditService.pending;

    // clear the search field after a successful booking (shortened flow keeps this widget mounted)
    useEffect(() => {
        if (successBar) {
            setMediumNumber('');
        }
    }, [successBar]);

    const checkMediumData = () => {
        // reset a failed booking from a previous shortened flow so it doesn't hide the detail page
        dispatch(postCreditServiceInit())
        dispatch(fetchMediumData(mediumNumber, singleQuickCreditAmountInCent))
    }

    const changeMediumNumber = (value: string) => {
        if (successBar) {
            dispatch(closeSuccessBar());
        }
        setMediumNumber(value.replace(/[^a-zA-Z0-9ÄÖÜäöü]/g, '').toUpperCase());
    }

    return (
        <div>
            <Breadcrumb isBackButtonDisabled />
            <Form loading={isPending}>
                <Grid>
                    <Grid.Column mobile={16} tablet={16} computer={8}>
                        {/* space is always reserved so the layout doesn't jump when the message shows/hides */}
                        <div style={{ minHeight: '44px', marginBottom: '1em' }}>
                            {successBar && (
                                // kept to a single line so a long text can't wrap and grow the reserved space on narrow viewports
                                <Message
                                    positive
                                    title={`${successBar.title} ${successBar.text}`}
                                    style={{ margin: 0, padding: '0.75em 1em', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                                >
                                    <strong>{successBar.title}</strong> {successBar.text}
                                </Message>
                            )}
                        </div>
                        <Header as='h3'>Mediennummer oder Kennzeichen eingeben</Header>
                        <br />
                        <Form.Group widths='equal'>
                            <Form.Field>
                                <Input
                                    fluid
                                    id='mediumNumber'
                                    aria-label='Mediennummer oder Kennzeichen'
                                    placeholder='Mediennummer oder Kennzeichen'
                                    value={mediumNumber}
                                    onChange={(e) => changeMediumNumber(e.target.value)}
                                />
                                <small style={{ display: 'block', marginTop: '0.5em', color: 'rgba(0, 0, 0, 0.6)' }}>
                                    Kennzeichen ohne Leerzeichen, Bindestrich oder andere Sonderzeichen eingeben, z. B. XXYY1234.
                                </small>
                            </Form.Field>
                        </Form.Group>
                    </Grid.Column>
                    <Grid.Column mobile={1} tablet={16} computer={8}></Grid.Column>
                    <Grid.Column mobile={16} tablet={16} computer={16}>
                        <Button
                            type='submit'
                            floated='right'
                            disabled={mediumNumber === '' || isPending}
                            onClick={checkMediumData}>
                            Bestätigen
                        </Button>
                    </Grid.Column>
                </Grid>
            </Form>
        </div>
    )
}

export default EnterMediumWidget;
